import Jt808SetAllReportIntervalModal from './jt808-set-all-report-interval-modal.vue'
export default Jt808SetAllReportIntervalModal
